module.exports = __webpack_public_path__ + "static/media/BPS.bdf6daeb.pdf";